import { render, staticRenderFns } from "./HomeTabsSugal.vue?vue&type=template&id=0bbe49de&scoped=true&"
import script from "./HomeTabsSugal.vue?vue&type=script&lang=ts&"
export * from "./HomeTabsSugal.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTabsSugal.vue?vue&type=style&index=0&id=0bbe49de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe49de",
  null
  
)

export default component.exports